import { render, staticRenderFns } from "./RecruitCpList.vue?vue&type=template&id=4dff2895&scoped=true&"
import script from "./RecruitCpList.vue?vue&type=script&lang=js&"
export * from "./RecruitCpList.vue?vue&type=script&lang=js&"
import style0 from "./RecruitCpList.vue?vue&type=style&index=0&id=4dff2895&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dff2895",
  null
  
)

export default component.exports